import { DeepPartial } from 'apprise-core/utils'
import { createProvider, createReadonlyProvider } from 'apprise-frontend-core/state/factory'
import { ParsingOptions, WorkBook, XLSX$Utils } from 'xlsx'

// ---------------------------------------------------------------------------------------------


// any state relevant to parser implementations and their initialistion.

export type ParseSupport = {

    // shared lazy-loaded implementation components.
    xlsx: {

        utils: XLSX$Utils
        read: (data: any, opts?: ParsingOptions) => WorkBook;
    }
}



export const [ParseSupportProvider, useParseSupport] = createProvider<ParseSupport>()


// ---------------------------------------------------------------------------------------------


// configuration for XLSX parsers.

export type XlsxParserConfig = {


    xslxMimeTypes?: string[]
    jsonMimeTypes?: string[]

    headerCornerstone: string | string[],

    headerCornerstoneColOffset?: number,
    headerCornerstoneRowOffset?: number,

    excludeSheet?: string[],
    excludeSheetIndex?: number[],

    includeSheet?: string[],
    includeSheetIndex?: number[],

    sheetKeys?: | Record<string, string[]>

    headerRowRadius?: number,
    headerColRadius?: number,

    rowRadius?: number,
    colRadius?: number,

    allowMissingCornerstone?: boolean
    allowMissingColumn?: boolean

    keys: Record<string, ParseKey>

    type?: DeepPartial<Record<string, Omit<XlsxParserConfig, 'type'> & {

        sheet?: Record<string, Partial<Omit<XlsxParserConfig, 'type' | 'sheet'>>>

    }>>

}

export type ParseKey = {
    key: string,
    tkey?: string,
    exact?: boolean,
    filter?: (row: any) => boolean,
    aliases?: Record<string, string | string[] | undefined>
    colAliases?: string | string[]
}

export const defaultParserConfig : Partial<XlsxParserConfig> = {

    xslxMimeTypes: ['application/vnd.openxmlformats-officedocument.spreadsheetml.sheet', 'application/vnd.ms-excel'],
    jsonMimeTypes: ['application/json'],

    headerRowRadius: 50,
    headerColRadius: 100,

    headerCornerstoneColOffset: 0,
    headerCornerstoneRowOffset: 0,

    allowMissingCornerstone: false

}

export const [XlsxParserConfigProvider, useXlsxParserConfig] = createReadonlyProvider<XlsxParserConfig>(defaultParserConfig)

